import { func } from "prop-types";
import { useState } from "react";

import styled from "styled-components";

import { useLogout } from "CrossFeatureComponents/MemberToolbar/API/queries";
import { menuTypographyProps } from "NavBar/components/NavLink";
import SettingsOptionsWrapper from "NavBar/components/settings/SettingsOptionsWrapper";
import { menuIconProps } from "NavBar/styleConstants";

import FnrButton from "UI/FnrButton3";
import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTypography from "UI/FnrTypography";

import externalNavigate from "Utilities/externalNavigate";

const LogoutPopperContent = ({ setCloseTrigger }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { mutateAsync } = useLogout({ invalidate: false });

  return (
    <SettingsOptionsWrapper>
      <WarningText>
        <FnrTypography fontSize="sm" color="textLight">
          Are you sure you want to logout?
        </FnrTypography>
      </WarningText>
      <ButtonsWrapper>
        <FnrButton
          borderRadius="18px"
          size="small"
          color="gray"
          onClick={() => {
            setCloseTrigger({});
          }}
          disabled={isLoading}
          data-cy="NavBar_CancelLogoutButton"
        >
          <FnrTypography {...menuTypographyProps}>Cancel</FnrTypography>
        </FnrButton>
        <FnrButton
          borderRadius="18px"
          size="small"
          color="blue"
          onClick={async () => {
            setIsLoading(true);
            setCloseTrigger({});
            await mutateAsync();
            externalNavigate("/login", "_self");
          }}
          disabled={isLoading}
          data-cy="NavBar_LogoutButton"
        >
          <ButtonContentWrapper>
            <FnrTypography {...menuTypographyProps}>
              Yes, log me out
            </FnrTypography>
            <FnrContainedIcon
              isLoading={isLoading}
              icon="right-from-bracket fas"
              noPadding
              {...menuIconProps}
            />
          </ButtonContentWrapper>
        </FnrButton>
      </ButtonsWrapper>
    </SettingsOptionsWrapper>
  );
};

LogoutPopperContent.propTypes = { setCloseTrigger: func };

const ButtonContentWrapper = styled.div`
  display: flex;
  gap: 4px;
`;

const WarningText = styled.div`
  text-align: center;
  padding: 2px 4px 4px 4px;
  max-width: 300px;
`;

const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 8px;
`;

export default LogoutPopperContent;
